import 'react-app-polyfill/ie9';
import { start } from '@jutro/app';
import { subscribe, JUTRO_TOPICS } from '@jutro/events';
import { LocaleService, G11nstore } from 'gw-portals-i18n-react';
import wmicTheme from 'wmic-qb-digital-theme-styles';
import { getConfigValue } from '@jutro/config';

import { WMICRegionUrlUtil } from 'wmic-portals-url-js';
import { CONSTANTS } from 'wmic-portals-utils-js';
import {
    BrowserRouter
} from 'react-router-dom';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import 'regenerator-runtime';

import { loadGoogleApiScript } from 'gw-ext-google-tools';
import App from './app/App';


import { initializeDataLayer } from './utils/dataLayer';

import { configureLegacyComponentMap } from '@jutro/legacy/uiconfig';
configureLegacyComponentMap();


initializeDataLayer();

// Set app locale and language to 'en-US'
const localeInstance = new LocaleService();
localeInstance.saveLocale('en-US');
localeInstance.saveLanguage('en-US');


const oneincScriptUrl = appConfig.serviceUrls.oneIncScriptUrl;
const oneIncScript = document.createElement('script');
oneIncScript.type = 'text/javascript';
oneIncScript.async = true;
oneIncScript.src = oneincScriptUrl;
oneIncScript.onload = () => {
    window.__oneIncReady = true;
    window.dispatchEvent(new Event('oneIncReady'));
};
oneIncScript.onerror = () => {
    window.__oneIncFailed = true;
    window.dispatchEvent(new Event('oneIncFailed'));
};
document.head.appendChild(oneIncScript);

const getDefaultMessage = () => {
    let region = WMICRegionUrlUtil.getRegionByParam(window.location.search);
    if(!region) {
        region = WMICRegionUrlUtil.getRegion();
    }
    let result = appConfig.applicationDetails.applicationName;
    
    if (region === CONSTANTS.JURISDICTIONS.CA) {
        result = CONSTANTS.TITLE.CA;
    } else if (region === CONSTANTS.JURISDICTIONS.OR) {
        result = CONSTANTS.TITLE.OR;
    } else {
        result = CONSTANTS.TITLE.DEFAULT;
    }
    return result;
}

const recaptchaKey = appConfig.credentials.CAPTCHA_API_KEY;
const onloadScript = document.createElement('script');
onloadScript.append('function onRecaptchaLoadCallback() { window.recaptchaLoaded = true; }');
document.head.append(onloadScript);

const script = document.createElement('script');
script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}&onload=onRecaptchaLoadCallback`;
document.head.append(script);
const config = {
    ...appConfig.credentials
}

start(App, {
    rootId: 'root',
    messageLoader: LocaleService.loadMessages,
    coreMessageLoader: LocaleService.loadCoreMessages,
    themeConfig: wmicTheme,
    refreshOnLocaleChange: true,
    config: [config],
    Router: BrowserRouter,
    g11nStore: G11nstore(),
    routerBasename: '/quote-and-buy',

    onInit: () => {
        LocaleService.register();
        loadGoogleApiScript();
    },

    // PC logging - Subscribe to FETCH_ERROR events
    onRender: () => {
        // Subscribe to JSONRPC errors to log them to PC
        subscribe([JUTRO_TOPICS.FETCH_ERROR], (error) => {
            const logger = window.__wmicLogger;
            if (logger) {
                // Transform JSONRPC error structure to match what responseError expects (axios format)
                const transformedError = {
                    status: error.status || (error.isTimeout ? 0 : 500),
                    statusText: error.baseError || 'JSONRPC Error',
                    data: error.data,
                    config: {
                        url: error.gwInfo?.serviceEndPoint,
                        data: {
                            method: error.gwInfo?.method
                        }
                    }
                };
                logger.responseError(transformedError);
            }
        });
    },
    

    appName: {
        id: 'digital.appName',
        defaultMessage: getDefaultMessage()
    },

    appDescription: 'W Insurance Renters Insurance policy will protect your belongings from unforeseen challenges like fire, water or theft. Get a Online Renters Insurance quote today.',
});
